export enum TimeTrackingRecordGroupingEnum {
  COMBINED = 'COMBINED',
  SEPARATE = 'SEPARATE'
}
